var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import AdBlockDTO from "@domains/dto/AdBlockDTO";
import OfferingsDTO from "@domains/dto/OfferingsDTO";
import HomePageOfferingDTO from "@domains/dto/AllOfferingsDTO";
import WebinarDTO from "@domains/dto/WebinarDTO";
import InvestorDTO from "@domains/dto/InvestorDTO";
import urlConfig from "@adapters/infrastructures/urlConfig/homeUrl";
var HomeRepository = /** @class */ (function () {
    function HomeRepository(commonQuotesHomePageRepository, http) {
        this.commonQuotesHomePageRepository = commonQuotesHomePageRepository;
        this.http = http;
    }
    HomeRepository.prototype.getWebinarData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var webinarData, webinar, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.http.request({
                                method: "GET",
                                url: urlConfig.home + "webinars",
                            })];
                    case 1:
                        webinarData = _a.sent();
                        if (webinarData) {
                            webinar = webinarData.data.webinars.map(function (webi) { return new WebinarDTO(webi); });
                            return [2 /*return*/, webinar];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HomeRepository.prototype.getNewUpdatesData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var adBlockData, adBlockDataList, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.http.request({
                                method: "GET",
                                url: urlConfig.home + "ad-blocks",
                            })];
                    case 1:
                        adBlockData = _a.sent();
                        if (adBlockData) {
                            adBlockDataList = adBlockData.data.map(function (adblock) { return new AdBlockDTO(adblock); });
                            return [2 /*return*/, adBlockDataList];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HomeRepository.prototype.getHomePageOfferingsData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_3, emptyData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.fetchOfferings()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_3 = _a.sent();
                        emptyData = {
                            primary: [],
                            secondary: [],
                            tertiary: [],
                        };
                        return [2 /*return*/, emptyData];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HomeRepository.prototype.fetchOfferings = function () {
        return __awaiter(this, void 0, void 0, function () {
            var offeringsData, primary, secondary, tertiary, AllOfferingsData, error_4, emptyData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.http.request({
                                method: "GET",
                                url: urlConfig.home + "offerings",
                            })];
                    case 1:
                        offeringsData = _a.sent();
                        if (offeringsData) {
                            primary = offeringsData.data.home_page_Offering.primary.map(function (offerings) { return new OfferingsDTO(offerings); });
                            secondary = offeringsData.data.home_page_Offering.secondary.map(function (offerings) { return new OfferingsDTO(offerings); });
                            tertiary = offeringsData.data.home_page_Offering.tertiary.map(function (offerings) { return new OfferingsDTO(offerings); });
                        }
                        AllOfferingsData = new HomePageOfferingDTO(primary, secondary, tertiary);
                        return [2 /*return*/, AllOfferingsData];
                    case 2:
                        error_4 = _a.sent();
                        emptyData = {
                            primary: [],
                            secondary: [],
                            tertiary: [],
                        };
                        return [2 /*return*/, emptyData];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HomeRepository.prototype.getNewOnEdelData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.commonQuotesHomePageRepository.getNewOnEdelData()];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_5 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    HomeRepository.prototype.getMarketNewsData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    return [2 /*return*/, this.commonQuotesHomePageRepository.getMarketNewsData()];
                }
                catch (error) {
                    return [2 /*return*/, []];
                }
                return [2 /*return*/];
            });
        });
    };
    HomeRepository.prototype.getInvestorData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var investorData, investorDataList, error_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.http.request({
                                method: "GET",
                                url: urlConfig.home + "better-investors",
                            })];
                    case 1:
                        investorData = _a.sent();
                        if (investorData) {
                            investorDataList = investorData.data.betterInvestor.map(function (investor) { return new InvestorDTO(investor); });
                            return [2 /*return*/, investorDataList];
                        }
                        else {
                            return [2 /*return*/, []];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_6 = _a.sent();
                        return [2 /*return*/, []];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return HomeRepository;
}());
export default HomeRepository;
